import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CuentasenviadasComponent } from './cuentasenviadas.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [ CuentasenviadasComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ]
})
export class CuentasenviadasModule { }
